import './RequestType.scss';
import { prefixClass } from 'lib/utils';
import classNames from 'classnames';
import { AskRequestType } from '@hone-automation/common';
import { Tooltip } from '../Tooltip';

export const mapAskRequestTypeToShortLabel: Record<AskRequestType, string> = {
  'Ask Bookkeeper': 'Transaction',
  'Ask Customer': 'Info',
  'Flagged Cell': 'Cell',
  'Flagged Report': 'General',
  'Customer Request': 'General',
  Email: 'Email',
  Group: 'Group',
};

// Full labels for detail views
export const mapAskRequestTypeToLabel: Record<AskRequestType, string> = {
  'Ask Bookkeeper': 'Flagged transaction',
  'Ask Customer': 'Needs Information',
  'Flagged Cell': 'Flagged Cell',
  'Flagged Report': 'Flagged Report',
  'Customer Request': 'Custom Request',
  Email: 'Email',
  Group: 'Group',
};

interface RequestTypeProps {
  type: keyof typeof mapAskRequestTypeToShortLabel;
  size?: 'default' | 'small';
  /** Whether to show the built-in tooltip (default: true) */
  showTooltip?: boolean;
}

const RequestType = ({ type, size, showTooltip = true }: RequestTypeProps) => {
  const prefix = prefixClass('q2-request-type');
  const typeLabel = mapAskRequestTypeToShortLabel[type];

  const badge = (
    <div className={classNames(prefix(), size, typeLabel.toLowerCase())}>
      {size === 'small' ? typeLabel.slice(0, 1) : typeLabel}
    </div>
  );

  if (!showTooltip) {
    return badge;
  }

  return (
    <Tooltip content={type} position="top" alignment="center" showDelay={600}>
      {badge}
    </Tooltip>
  );
};

export default RequestType;
